// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__DUkEc","label":"Labeled_label__rzFaF","divider":"Labeled_divider__dYJNM"};